module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am644-2b10a354eed9ada155c4f7c1ad1f6f95.jpg";